// prevents unauthenticated or unauthorized users from accessing restricted routes
import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService, RouteNavigationService } from '@services/index';

// Makes sure their is a current tenant
// before allowing navigation to the login component
@Injectable({ providedIn: 'root' })
export class TenantAuthGuard implements CanActivate {
  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private routeNavService: RouteNavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentTenant = this.authenticationService.currentTenantValue;

    // redirect if current subdomain is different from the current tenant sub domain
    // (Sub domain name change and then refresh/navigate)
    const subDomain = route.url[0].path;
    if (currentTenant) {
      if (subDomain !== currentTenant.subDomainName) {
        this.authenticationService.logout(true, subDomain);
        return false;
      }
      return true;
    }

    // not logged in so redirect to tenant component with new unidentified subdomain name
    this.routeNavService.explicitNavigate(subDomain, this.returnUrl);
    return false;
  }

  get returnUrl() {
    return this.route.snapshot.queryParams['returnUrl'] || null;
  }
}
